import styled from "styled-components";

import media from "constants/media";
import { skeleton } from "components/shared/skeleton/Skeleton";

export const CartStyled = styled.ul`
    margin: 0 0 20px;

    ${media.mdUp`
        margin-bottom: 40px;
    `}
`;

export const CartItemSkeleton = styled.li`
    ${skeleton}

    position: relative;

    width: 100%;
    height: 82px;
    margin-bottom: 10px;

    list-style: none;

    ::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background-image: url("/images/lees-cadeau-throbber.gif");
        background-repeat: no-repeat;
        background-position: center;
        background-size: auto 100%;

        content: "";
    }

    ${media.mdUp`
        height: 90px;
    `}
`;
